import * as React from 'react';
import clsx from 'clsx';
import { Variant } from './Variant';

interface NotificationProps extends React.HTMLAttributes<HTMLDivElement> {
    variant: Variant | string;
    message: string;
    id: string;
    closable?: boolean;
}

const Notification = React.forwardRef<HTMLDivElement, NotificationProps>((
    {
        variant,
        message,
        id,
        closable
    },
    ref
): React.ReactElement => {
    return (
        <div
            ref={ref}
            className={clsx(
                'alert',
                `alert-${variant}`
            )}
        >
            {message}
        </div>
    );
});

Notification.displayName = 'Notification';

export default Notification;
